import EveThemeProvider from '@ashn/eve-themes-react/EveThemeProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics } from './utils/analyticsSetup';
import mswStarterLogic from './utils/mswStarterLogic';

const root = ReactDOM.createRoot(document.getElementById('root'));
initializeAnalytics();
mswStarterLogic().then(() =>
	root.render(
		<QueryClientProvider client={new QueryClient()}>
			<HelmetProvider>
				<React.StrictMode>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<EveThemeProvider themeKey='internal' themeMode='light'>
							<CssBaseline />
							<App />
						</EveThemeProvider>
					</LocalizationProvider>
				</React.StrictMode>
			</HelmetProvider>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	)
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
